import ratingFillIcon from "@/public/icons/rating-fill.svg";
import ratingIcon from "@/public/icons/rating.svg";

export const RatingIndicator = ({
  rating,
  max,
  label,
}: {
  rating: number;
  max: number;
  label: string;
}) => (
  <ul className="flex flex-row gap-1">
    {[...Array(max)]
      .map((_, i) => i)
      .reverse()
      .map((i) => (
        <img
          key={i}
          src={rating > i ? ratingFillIcon : ratingIcon}
          alt={`${label}: ${i + 1}`}
        />
      ))}
  </ul>
);
